import AnnexGroupTableOfContentsRecord from "models/view-models/table-of-contents/annex-group-table-of-contents-record";
import TableOfContentsCollapsePanelLinkWithinPanel from "pages/notebooks/notebook-reference-panel/bookview/table-of-contents/table-of-contents-collapse-panel-link-within-panel";
import React from "react";
import PublicationComponentType from "utilities/enumerations/publication-component-type";
import { useLocalization } from "utilities/hooks/use-localization";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------
interface VirtualTableOfContentsAnnexGroupProps {
    annexGroup: AnnexGroupTableOfContentsRecord;
    annexNfpaLabel: string;
    isPublic?: boolean;
}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Component
// -----------------------------------------------------------------------------------------

const VirtualTableOfContentsAnnexGroup = (
    props: VirtualTableOfContentsAnnexGroupProps
) => {
    const { annexGroup, isPublic = false } = props;

    const { t } = useLocalization();

    return (
        <TableOfContentsCollapsePanelLinkWithinPanel
            dataTestId="annex-group-link"
            dataTestDisplaySequence={annexGroup.groupBy}
            hasBookmark={annexGroup.hasBookmark}
            index={annexGroup.groupBy}
            isPublic={isPublic}
            caapsId={annexGroup.groupBy}
            publicationComponentType={PublicationComponentType.AnnexGroup}
            parentId={annexGroup.annexId?.toString()}>
            <span>{t("chapterNumber", { number: +annexGroup.groupBy })}</span>
        </TableOfContentsCollapsePanelLinkWithinPanel>
    );
};

// #endregion Component

// -----------------------------------------------------------------------------------------
// #region Export
// -----------------------------------------------------------------------------------------

export default VirtualTableOfContentsAnnexGroup;

// #endregion Export
